document.addEventListener("DOMContentLoaded", function () {
  // ==========================================
  // 1. REVIEW SLIDER (Continuous AutoScroll Marquee)
  // ==========================================
  var reviewSliderEl = document.querySelector("#review-slider");
  if (reviewSliderEl) {
    var reviewSlider = new Splide("#review-slider", {
      type: "loop",
      perPage: 4,
      gap: "40px",
      arrows: false,
      pagination: false,
      drag: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoScroll: {
        speed: 1, // Control speed here (higher number = faster continuous scrolling)
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        575: { perPage: 1 },
      },
    });

    // Mount with extensions if available for autoScroll support
    if (window.splide && window.splide.Extensions) {
      reviewSlider.mount(window.splide.Extensions);
    } else {
      reviewSlider.mount();
    }
  }

  // ==========================================
  // 2. TESTIMONIAL SLIDER (Continuous AutoScroll Marquee)
  // ==========================================
  var esbTestiSliderEl = document.querySelector("#esb-testi-slider");
  if (esbTestiSliderEl) {
    var esbTestiSlider = new Splide("#esb-testi-slider", {
      type: "loop",
      perPage: 3,
      gap: "20px",
      arrows: false,
      pagination: false,
      drag: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoScroll: {
        speed: 1.2, // Adjust speed for testimonial marquee track
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        575: { perPage: 1 },
      },
    });

    if (window.splide && window.splide.Extensions) {
      esbTestiSlider.mount(window.splide.Extensions);
    } else {
      esbTestiSlider.mount();
    }
  }

  // ==========================================
  // 3. HERO MAIN SLIDER (Standard Slide Transition)
  // ==========================================
  var sliderEl = document.querySelector("#slider");
  if (sliderEl) {
    new Splide("#slider", {
      type: "loop",
      perPage: 1,
      autoplay: true,
      interval: 3000, // Speed control: Slides transition every 3.5 seconds
      arrows: false,
    }).mount();
  }

  // ==========================================
  // 4. COUNTER NUMBER ANIMATION (Scroll Triggered)
  // ==========================================
  var counters = document.querySelectorAll(".counter");

  var startCounterAnimation = function (counter) {
    var target = parseFloat(counter.getAttribute("data-target"));
    var isDecimal = target % 1 !== 0;
    var count = 0;
    var speed = 80; // Total frames for animation duration control

    var updateCounter = function () {
      var increment = target / speed;

      if (count < target) {
        count += increment;
        counter.innerText = isDecimal ? count.toFixed(1) : Math.ceil(count);
        requestAnimationFrame(updateCounter);
      } else {
        counter.innerText = isDecimal ? target.toFixed(1) : target;
      }
    };

    updateCounter();
  };

  if (counters.length) {
    var counterObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var counterEl = entry.target;
            startCounterAnimation(counterEl);
            observer.unobserve(counterEl); // Runs only once when scrolling into view
          }
        });
      },
      {
        threshold: 0.2,
      },
    );

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  }

  // ==========================================
  // 5. ACCORDION LOGIC (Toggle Active States)
  // ==========================================
  var accordionButtons = document.querySelectorAll(".esb-accordion__btn");

  accordionButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var currentItem = button.closest(".esb-accordion__item");

      // Close all other active accordion panels
      document
        .querySelectorAll(".esb-accordion__item")
        .forEach(function (item) {
          item.classList.remove("is-active");
        });

      // Open the clicked accordion panel
      currentItem.classList.add("is-active");
    });
  });
});


// NEW JS

const locomotiveScroll = new LocomotiveScroll();

// ── Header ────────────────────────────────────────────────────────────────────

const esHeader = document.getElementById("es-header");
const esHamburger = document.getElementById("es-hamburger");
const esMobileNav = document.getElementById("es-mobile-nav");

// Sticky shadow on scroll
window.addEventListener("scroll", () => {
  if (!esHeader) return;
  esHeader.classList.toggle("is-scrolled", window.scrollY > 80);
});

// Mobile nav toggle
if (esHamburger && esMobileNav && esHeader) {
  esHamburger.addEventListener("click", () => {
    const isOpen = esMobileNav.classList.toggle("is-open");
    esHeader.classList.toggle("is-open", isOpen);
    esHamburger.setAttribute("aria-expanded", String(isOpen));
    esMobileNav.setAttribute("aria-hidden", String(!isOpen));
  });

  // Close on mobile nav link click
  esMobileNav
    .querySelectorAll(".es-header__mobile-nav-link")
    .forEach((link) => {
      link.addEventListener("click", () => {
        esMobileNav.classList.remove("is-open");
        esHeader.classList.remove("is-open");
        esHamburger.setAttribute("aria-expanded", "false");
        esMobileNav.setAttribute("aria-hidden", "true");
      });
    });
}

// ── Feedbacks ────────────────────────────────────────────────────────────────────
new Splide(".es-feedbacks__slider", {
  type: "loop",
  perPage: 3,
  perMove: 1,
  gap: "20px",
  autoplay: true,
  interval: 3000,
  speed: 800,
  pauseOnHover: true,
  arrows: false,
  pagination: false,

  breakpoints: {
    1000: {
      perPage: 2,
    },
    768: {
      perPage: 2,
    },
    480: {
      perPage: 1,
    },
  },
}).mount();



